import React from 'react'
import { useTranslation } from 'react-i18next'

import StartEndDateRangeFields from '../../../../../ReusableFormFields/StartEndDateRangeFields'

import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'

function RightDatesSection({ formik }) {
  const drawerFormClasses = useDrawerFormStyles()

  const { t } = useTranslation()

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={drawerFormClasses.sectionTitle}>{t('Right dates (optional)')}</h3>
      <p>{t('Please enter the start and end date of the right.')}</p>
      <StartEndDateRangeFields formik={formik} />
    </section>
  )
}

export default RightDatesSection
